import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e596f8bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-container"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "list-container"
}
const _hoisted_4 = ["onClick"]

import { ref, onMounted, nextTick, computed } from "vue" 


    
export default /*#__PURE__*/_defineComponent({
  __name: 'filterPopup',
  props: ["itemList", "displayedAttribute", "selectMultiple", "selectedItems"],
  emits: ["itemSelected", "filterClosed", "filterReset"],
  setup(__props, { emit: __emit }) {

    const props = __props
    
    // Provide default value for selectedItems to prevent undefined errors
    const selectedItems = computed(() => props.selectedItems || [])
    const emits = __emit
    const reusableFilterPopup = ref<HTMLDivElement | null>(null)

    function selectItem(item: string | undefined){
        if(item === undefined){
            emits("itemSelected", undefined)
            emits("filterReset")
            emits("filterClosed")
            return
        }
        emits("itemSelected", item)

    }

    const closeFilter = () => {
        emits("filterClosed")
    }

    onMounted(() =>  {
        nextTick(() => {
            reusableFilterPopup.value?.focus()!
        })
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    tabindex: "0",
    onBlur: _cache[2] || (_cache[2] = ($event: any) => (closeFilter())),
    ref_key: "reusableFilterPopup",
    ref: reusableFilterPopup,
    class: "filter-popup container top-[4.8rem] z-20 border text-2xl shadow-xl top-16 py-4 w-[150%] rounded-xl border-gray-300"
  }, [
    (typeof(__props.itemList[0]) === 'string')
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.itemList, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass([{'filter-item-selected': selectedItems.value.includes(item)}, "mb-4 cursor-pointer p-4 px-8 select-none"]),
              key: item,
              onClick: ($event: any) => (selectItem(item))
            }, _toDisplayString(item), 11, _hoisted_2))
          }), 128)),
          _createElementVNode("li", {
            class: "mb-4 cursor-pointer p-4 px-8 select-none text-gray-400",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (selectItem(undefined)))
          }, " Sıfırla ")
        ]))
      : (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.itemList, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass([{'filter-item-selected': selectedItems.value.some(selected => selected?.id === item.id)}, "mb-4 cursor-pointer p-4 px-8 select-none"]),
              key: item.id,
              onClick: ($event: any) => (selectItem(item))
            }, _toDisplayString(item[__props.displayedAttribute]), 11, _hoisted_4))
          }), 128)),
          _createElementVNode("li", {
            class: "mb-4 cursor-pointer p-4 px-8 select-none text-gray-400",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (selectItem(undefined)))
          }, " Sıfırla ")
        ]))
  ], 544))
}
}

})